import { render } from "./Numbered.vue?vue&type=template&id=207685d0&scoped=true"
import script from "./Numbered.vue?vue&type=script&lang=js"
export * from "./Numbered.vue?vue&type=script&lang=js"

import "./Numbered.vue?vue&type=style&index=0&id=207685d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207685d0"]])

export default __exports__